// extracted by mini-css-extract-plugin
module.exports = {"block":"Location_block__3anEg","check":"Location_check__1lfrh","selected":"Location_selected__1y02l","name":"Location_name__2i9R7"};